import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Params, QueryParamsHandling, RouterModule } from '@angular/router';
import { AtaraxiaOnDestroyDirective } from '@epicuro-next/ataraxia/on-destroy';
import { dynamicElementsLinkKey } from '@epicuro-next/constants/dynamic-elements';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { Operation } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { DynamicLogicalOperationsModule } from '@epicuro-next/platform/dynamic-logical-operations';
import { LetDirective } from '@ngrx/component';

type RouterLinkType = string | string[] | null;

@DynamicComponentRegister(dynamicElementsLinkKey, true)
@Component({
  selector: 'epc-dynamic-elements-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  hostDirectives: [AtaraxiaOnDestroyDirective],
  imports: [
    CommonModule,
    RouterModule,
    DynamicLogicalOperationsModule,
    LetDirective,
  ],
})
export class DynamicElementsLinkComponent {
  @Input() public routerLink: RouterLinkType = null;
  @Input() public target = '_self';
  @Input() public hrefUrl: string | null = null;
  @Input()
  public params: Params | null = null;
  @Input()
  public linkText: string | null = null;

  @Input()
  public paramsHandling: QueryParamsHandling = '';

  @Input()
  public disabled: Operation | null = null;

  @Input()
  public isStopPropagation = true;
}

DontTreeShake(DynamicElementsLinkComponent);
